export default __webpack_public_path__ + "static/media/SWT1180.34I-43203_-25827_0.93f3bea9.jpg";